<!-- CONTAINER -->
<div class="container content-area relative">

    <!-- PAGE-HEADER -->
    <div class="page-header">
        <h4 class="page-title">Approve/Reject Blog</h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
            <li class="breadcrumb-item"><a [routerLink]="['/admin/blog/new']">Blog</a></li>
            <li class="breadcrumb-item active" aria-current="page">Edit</li>
        </ol>
    </div>
    <!-- PAGE-HEADER END -->
    
    <!-- ROW-1 OPEN -->
    <div class="row" id="user-profile">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div>
                        <form [formGroup]="formGroup" (submit)="approveRejectBlog()">
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <label for="categoryname">Title</label>
                                        <input type="text" class="form-control" [value]="data.blogTitle" readonly>
                                       
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <label for="categoryname">Status</label>
                                        <br>
                                        <span class="mr-2"><input type="radio" [value]="true" formControlName="isApproved"> Approve</span>
                                        <span class=""><input type="radio" [value]="false" formControlName="isApproved"> Reject</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">                            
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label for="adminComments">Remarks:</label>
                                        <input type="text" class="form-control"  placeholder="Remarks"
                                            formControlName="adminComments">
                                        <small
                                            *ngIf="f.adminComments.invalid && (f.adminComments.dirty || f.adminComments.touched)"
                                            class="d-block alert alert-danger mt-1">
                                            Required
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-success mt-1"
                                    [disabled]="!formGroup.valid">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div><!-- COL-END -->
    </div>
    <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->